import Cookies from "js-cookie";
import { CookieNames } from "./cookie-names";
// Setting lll_oidc_token cookie for backwards compatibility needed by ecomm-checkout-client
export function setOIDCCookie(token) {
    return Cookies.set(CookieNames.OIDC_COOKIE, token.accessToken, {
        secure: true,
        sameSite: "secure",
        expires: new Date(token.expiresAt * 1000)
    });
}
// Setting lll_refresh_token cookie for backwards compatibility needed by ecomm-checkout-client
export function setRefreshTokenCookie(token) {
    return Cookies.set(CookieNames.LLL_REFRESH_TOKEN, true, {
        secure: true,
        sameSite: "secure",
        expires: new Date(token.expiresAt * 1000)
    });
}
